import * as Styled from './styled'
import { TABS, getTabsData } from './config'
import { useCallback, useEffect } from 'react'
import { dispatch } from 'store'
import { aiLibThunks } from 'store/features/aiLibVideo/thunks'
import { aiLibImageThunks } from 'store/features/aiLibImage/thunks'
import { Tabbar } from 'common-components'
import { aiLibSelectors } from 'store/features/aiLibVideo/selectors'
import { useSelector } from 'react-redux'

const AiLibContent: React.FC = () => {
  const tabsData = getTabsData()
  const activeTab = useSelector(aiLibSelectors.activeTab)

  const handleTabClick = useCallback(
    (tab: string) => {
      if (tab !== activeTab) {
        dispatch(aiLibThunks.setActiveTab(tab))
      }
    },
    [activeTab]
  )

  useEffect(() => {
    dispatch(aiLibThunks.closeFilters())
    dispatch(aiLibImageThunks.closeFilters())
  }, [])

  return (
    <Styled.AiLibContainer>
      <Tabbar
        data={tabsData.map(tab => ({ ...tab, id: tab.name }))}
        activeTabName={activeTab}
        setActiveTabName={handleTabClick}
      />
      {TABS.map(tab =>
        tab.key === activeTab ? (
          <Styled.AILibContentWrapper key={tab.key} $isActive>
            {tab.content}
          </Styled.AILibContentWrapper>
        ) : null
      )}
    </Styled.AiLibContainer>
  )
}

export default AiLibContent
